import React, { useState } from "react";
import { blue, red, yellow, green } from "@mui/material/colors";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";

import { WithdrawalRequest, Physician } from "../../../../models";
import dayjs from "dayjs";
import PhysicianListWidget from "../physicians/physician-list.component";
import Centered from "../../../../components/Centered";
import { titleCase, to2DecimalPlaces } from "../../../../helpers";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import api from '../../../../api/medAppApi';
import AppLink from "../../../../components/AppLink";
import { ROUTES } from "../../../../history";
import { useMutation } from "react-query";
import { putMessage } from "../../../app/store/actions";
import { useDispatch } from "react-redux";

const WithdrawalRequestView: React.FC<{
  withdrawalRequest: WithdrawalRequest;
  
}> = ({ withdrawalRequest }) => {
    const [request, setRequest] = useState(withdrawalRequest)
    const dispatch = useDispatch();
  const getColor = (): string => {
    let color: string;
    switch (request.status) {
      case "Approved":
        color = blue[700];
        break;
      case "Failed":
        color = red[700];
        break;
      case "Declined":
        color = red[700];
        break;
      case "Completed":
        color = green[700];
        break;
      default:
        color = yellow[800];
        break;
    }
    return color;
  };

  const updateStatus = async (req: WithdrawalRequest) => {
    const resp = await api.updateModel<WithdrawalRequest>({modelName: 'withdrawalrequest', where: {id: req.id}, update: {
        status: "Declined",
        statusReason: "Declined by admin"
    }})
    if(resp.errorData) {
        throw new Error(resp.errorData.problems || 'Something went wrong');
    } else if(resp.error) {
        throw new Error(resp.error || 'Something went wrong'); 
    }
    return resp;
  }
  const {mutate, isLoading} = useMutation({
        mutationFn: updateStatus,
        mutationKey: 'update-withdrawal-request-' + request.id,
        onSuccess: (d) => {
            setRequest({...d.data!.data.model, physician: withdrawalRequest.physician})
            dispatch(putMessage({
                type: 'success',
                message: 'Declined successfully'
            }))
        },
        onError: () => {
            dispatch(putMessage({
                type: 'error',
                message: 'Something went wrong'
            }))
        }
  })



  const physician = request!.physician as Physician;
  const name = titleCase(`Dr. ${physician.FirstName} ${physician.LastName}`);
  return (
    <Centered>
      <Paper
        style={{
          padding: "1em",
          borderRadius: "14px",
          border: "none",
          width: "80%",

          maxWidth: "450px",
        }}
        elevation={2}
      >
       {isLoading && <LinearProgress />}
        <Typography
          textAlign={"center"}
          fontWeight="bold"
          component="h6"
          variant="h6"
        >
          {"Request from " + name}
        </Typography>
        <Typography
          variant="subtitle1"
          fontSize={"14px"}
          color={"#6B779A"}
          textAlign={"center"}
          sx={{
            mt: 1,
          }}
        >
          {dayjs(request.createdAt).format("ddd MMM D, HH:mm")}
        </Typography>
        <Typography
          variant="h3"
          fontSize={"14px"}
          textAlign={"center"}
          sx={{
            mt: 1,
          }}
        >
          NGN{to2DecimalPlaces(request.amount, true)}
        </Typography>
        <Typography
          variant="subtitle1"
          color={getColor()}
          textAlign={"center"}
          sx={{
            mt: 1,
            mb: 2,
          }}
        >
          {request.status}
        </Typography>
        <div
          style={{
            padding: "1em",
            borderRadius: "24px",
            backgroundColor: "#F8F8FA",
            marginBottom: "2em",
          }}
        >
          <Typography fontWeight={"bold"}>Physician</Typography>
          <PhysicianListWidget physician={request!.physician as Physician} />
        </div>

{request.status === 'Pending' ? (        <Box >
          <AppLink
            doNotUseButton
            to={
              ROUTES.ADMIN_BASE + "/withdrawal-requests/approve/" + request.id
            }
          >
            <Button variant="contained">Approve Withdrawal</Button>
            
          </AppLink>
          <Box mt={2}>
          <Button color="error" onClick={() => mutate(request)}>Decline Withdrawal</Button>
          </Box>
         
        </Box>): null}
      </Paper>
    </Centered>
  );
};

export default WithdrawalRequestView;
